import { Tier } from "types/api"

const TIER_NAME_MAP = {
  [Tier.ONE]: "Free",
  [Tier.TWO]: "SuperFan",
  [Tier.THREE]: "MegaFan",
}

export default TIER_NAME_MAP;